/*
 * -----------------------------------------------------------------------
 *  <copyright file="step4-overview.helper.ts company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import PanelConstants from '@components/central-monitoring/panels/add-panel/panel-constants';
import PanelService from '@components/central-monitoring/panels/add-panel/service';
import { IPanelExtended } from '@components/central-monitoring/panels/add-panel/step4-overview/step4-overview.interface';
import { PanelType } from '@types/graphql-global-types';

const { modelOptions } = PanelConstants;

export const checkStep4Availability = (state: IPanelExtended) => {
    const panelModel = PanelService.getPanelModel(state.modelParams);

    return (
        state.panelType === PanelType.MODEL &&
        (panelModel === modelOptions.RATE_GROUP ||
            panelModel === modelOptions.NEGATIVE_BINOMIAL ||
            panelModel === modelOptions.FUNNEL ||
            panelModel === modelOptions.TRI_OPERATIONAL)
    );
};
